import { render, staticRenderFns } from "./AssignmentIcon.vue?vue&type=template&id=f3c21d90&scoped=true&"
import script from "./AssignmentIcon.vue?vue&type=script&lang=js&"
export * from "./AssignmentIcon.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentIcon.vue?vue&type=style&index=0&id=f3c21d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c21d90",
  null
  
)

export default component.exports